import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
const CreateProjectAmendmentLog = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { id } = useParams();

  useEffect(() => {
    dispatch(updateNavbarHeading("Amendment Log"));
  }, []);

  useEffect(() => {
    if (id) {
      fetchAmendmentLogListingData(id)
    }
  }, [id]);
  const columns = {
    fieldName: { text: "Field Name", align: "start", visible: true ,width:"120px" },
    updated: { text: "Updated Date", align: "center", visible: true ,width:"60px"},
    previous: { text: "Previous Date", align: "center", visible: true,width:"60px" },
    updatedDate: { text: "Updated Date", align: "center", visible: true,width:"60px" },
    username: { text: "Updated By", align: "start", visible: true },
  };
  const [apiStatus, SetApiStatus] = useState(undefined);
    const [searchTerm, setSearchTerm] = useState("");
  
    const [amendmentListdata, setAmendmentListdata] = useState([])
  
  const fetchAmendmentLogListingData = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/ammedent-log/${id}`
      );

      SetApiStatus(response?.status);
      if (response?.status === 200) {
        const fetchData = response?.data?.data;
        console.log("fetchData", fetchData);

        setAmendmentListdata(fetchData);
      } else {
        console.error(
          "Failed to fetch asset categories. Server responded with status:",
          response
        );
      }
    } catch (error) {
      console.log("response-->", error);
    }
  };

  return(
    <div className="container-fluid" id="skill_section">
    <div className="container-fluid" id="skill-table-area">
      <div className="row">
      <Dynamic_PR_table
        data={amendmentListdata}
        columns={columns}
        itemsPerPage={8}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        showIcon1={true}
        showIcon2={true}
        isApiStatus={apiStatus}
        isRequiredStatus={true}
        showIcon3={false}
        showIcon4={false}
        showIcon5={false}
        isActionRequired={false}
        isAddNewBtnRequired={false}
        // handleIcon1={handleEdit}
        // handleAddNew={handleAddNewCreateProject}
        add
        more
        function
        icons={{
          Icon1: <i class="bi bi-pencil-square icons"></i>,
          Icon1Text: " Edit",
          // Icon1Flag:[],
          Icon2: <i class="bi bi-clock-history icons"></i>,
          Icon2Text: " Amendment Log",
        }}
      />
      </div>
    </div>
  </div>
  );
};

export default CreateProjectAmendmentLog;
